<!-- <header class="top-box-shadow settings-header">
<div class="columns is-gapless is-vcentered is-mobile">
  <div class="column is-12">
    <h3 class="is-marginless is-clearfix">My Subscription</h3>
  </div>
</div>
</header> -->
<app-page-header>
  <span class="page-title"><h3>Subscription</h3></span>
</app-page-header>
<section class="section setting-section">
  <div class="row">
    <!-- <div class="column is-half is-offset-one-quarter"> -->
    <div class="col">
      <div class="card box-overflow">
        <!-- <header class="is-size-5"> -->
        <!-- <p class="card-header-title is-size-5"></p> -->
        <!-- </header> -->
        <div class="pad-5-0">
          <div class="tabs is-centered">
            <ul>
              <li [ngClass]="{ 'is-active': tabName === 'subscription' }">
                <a (click)="selectSettingsTab('subscription')">
                  <span>My Subscription</span>
                </a>
              </li>
              <li [ngClass]="{ 'is-active': tabName === 'payment_history' }">
                <a (click)="selectSettingsTab('payment_history')">
                  <span>Payment History</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- User subscription -->
        @if (tabName === 'subscription') {
        <div
          class="card-body is-centered box-overflow user-settings scroll-bar"
        >
          @if (!isShowSubscription) {
          <div class="d-flex justify-content-center">
            <ul class="list-group">
              <li class="list-group-item">
                <div class="row">
                  <div class="col-md-5 subscription-plan-heading">
                    <p><b>Current Plan</b></p>
                  </div>
                  <div class="col-md-6 subscription-plan-heading">
                    <p class="plan-details">Absence GPT</p>
                    <a
                      class="plan-details-2 upgrade-btn"
                      (click)="changePlanOption()"
                      ><small>Upgrade plan</small></a
                    >
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <div class="col-md-5 subscription-plan-heading">
                    <p><b>Billing Period</b></p>
                  </div>
                  <div class="col-md-6 subscription-plan-heading">
                    <p class="plan-details">Annual</p>
                    <small>Next billing date - 18-09-2025</small>
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <div class="col-md-5 subscription-plan-heading">
                    <p><b>Billing Cycle</b></p>
                  </div>
                  <div class="col-md-6 subscription-plan-heading">
                    <p>Annually</p>
                    <!-- <p *ngIf="planName ==='Trial'">-</p> -->
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <div class="col-md-5 subscription-plan-heading">
                    <p><b>Billing Address</b></p>
                  </div>
                  <div class="col-md-6 subscription-plan-heading">
                    <!-- <p *ngIf="planName ==='Trial'">-</p>
                      <p class="plan-details">{{activePlanData.company_name}}</p>
                      <p class="plan-details">{{activePlanData.address1}}</p>
                      <p class="plan-details">{{activePlanData.address2}}</p>
                      <p class="plan-details">{{activePlanData.city}}</p>
                      <p class="plan-details">{{activePlanData.state}}</p>
                      <p class="plan-details">{{activePlanData.country}}</p>
                      <p class="plan-details">{{activePlanData.zip}}</p> -->
                  </div>
                </div>
              </li>
            </ul>
            <!-- <div class="card card-bordered">
              <div class="card-inner-group">
                <div class="card-inner">
                  <div class="flex-wrap between-center flex-md-nowrap">
                    <div class="columns is-vcentered">
                      <span class="column is-9">
                        <div class="sub-block-text">
                          <h6>Absence GPT <span class="text-base">$348.00 /
                          Annually</span></h6>
                          <p class="text-soft">Unlimited access question and answers with
                            support
                          24/7 </p>
                        </div>
                      </span>
                      <span class="column is-3">
                        <div class="sub-block-actions flex-shrink-0 pull-right">
                          <a class="button is-link is-small"
                          (click)="changePlanOption()">Upgrade Plan</a>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="sub-block-head">
              <div class="sub-block-head-content">
                <h5 class="sub-block-title">Billing Cycle</h5>
                <div class="sub-block-des">
                  <p>Your subscription renews on May 31, 2024 <span class="text-soft">(6 days
                  remining).</span></p>
                </div>
              </div>
            </div> -->
          </div>
          } @if (isSubscripeMorePlan) {
          <div class="sub-block">
            <div class="sub-block-head">
              <div class="sub-block-head-content">
                <h5 class="sub-block-title">Choose a plan</h5>
              </div>
            </div>
            <div class="row">
              <div class="plan-wrapper">
                <div class="col">
                  <div
                    class="card subscriptionCard shadow-md is-cursor-pointer transform is-duration-300 hover-shadow-xl hover-translate-y"
                  >
                    <h3 class="has-text-centered plan-name">Absence GPT</h3>
                    <div class="rate">
                      <h1 class="has-text-centered">
                        <small class="cost-symbol">$</small>
                        <span class="plan-cost">29</span>
                      </h1>
                      <p class="text-center plan-details">Per Month / User</p>
                      <p class="text-center plan-details">
                        $348 Billed Annually
                      </p>
                    </div>
                    <button
                      class="button is-link is-fullwidth"
                      (click)="makePayment(29, ' Absence GPT')"
                    >
                      Select Plan
                    </button>
                    <div class="feature">
                      <p>Available on Cloud</p>
                      <p>Admin Account for User Management</p>
                      <p>Federal and States Laws</p>
                      <p>Unlimited Questions and Answers</p>
                      <p>PDF File Download</p>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div
                    class="card subscriptionCard shadow-md is-cursor-pointer transform is-duration-300 hover-shadow-xl hover-translate-y"
                  >
                    <h3 class="has-text-centered plan-name">
                      Absence GPT + LMS
                    </h3>
                    <div class="rate">
                      <h1 class="has-text-centered">
                        <small class="cost-symbol">$</small
                        ><span class="plan-cost"> 49</span>
                      </h1>
                      <p class="text-center plan-details">Per Month / User</p>
                      <p class="text-center plan-details">
                        $588 Billed Annually
                      </p>
                    </div>
                    <button
                      class="button is-link is-fullwidth"
                      (click)="makePayment(49, 'Absence GPT + LMS')"
                    >
                      Select Plan
                    </button>
                    <div class="feature">
                      <p>Available on Cloud</p>
                      <p>Admin Account for User Management</p>
                      <p>Federal, States Laws and Company Policies</p>
                      <p>Upload Policy Documents</p>
                      <p>Assesment Test</p>
                      <p>Survey and Poll</p>
                      <p>Create Interactive Video Quizzes</p>
                      <p>Unlimited Questions and Answers</p>
                      <p>PDF File Download</p>
                      <p>Product Utilization Reports and Dashboards</p>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div
                    class="card subscriptionCard shadow-md is-cursor-pointer transform is-duration-300 hover-shadow-xl hover-translate-y"
                  >
                    <h3 class="has-text-centered plan-name">Enterprise</h3>
                    <div class="rate">
                      <h1 class="has-text-centered">
                        Contact Us For Flexible Plan
                      </h1>
                      <h1 class="plan-enterp-cost has-text-centered">
                        {{ supportMailId }}
                      </h1>
                      <p class="has-text-centered plan-details">
                        (408)745-9787
                      </p>
                    </div>
                    <button class="btn button is-link is-fullwidth">
                      <a href="mailto:support@absencegpt.ai">Contact Us</a>
                    </button>
                    <div class="feature">
                      <p>Cloud, On-Premises, Hybrid</p>
                      <p>Multiple Administrators</p>
                      <p>User Management & Single Sign On (SSO)</p>
                      <p>API Integration</p>
                      <p>Fine-tune Absence GPT</p>
                      <p>Federal,States Laws and Corporate Policies</p>
                      <p>Upload Policy Documents</p>
                      <p>Assesment Test</p>
                      <p>Survey and Poll</p>
                      <p>Create Interactive Video Quizzes</p>
                      <p>Unlimited Questions and Answers</p>
                      <p>PDF File Download</p>
                      <p>Utilization Reports and Dashboards</p>
                      <p>Integrate With Your Website</p>
                      <p>Integrate With Third-party Applications</p>
                      <p>Any REST APIs Integration</p>
                      <p>Develop new Features to Support Your Business</p>
                      <p>Automate File Upload, and SFTP</p>
                      <p>White Labelling</p>
                      <p>Application, Model Training and Maintenance</p>
                      <p>Project Management Team</p>
                      <p>Implementation Team</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          } @if (isSubscriptPaymentOption) {
          <div class="sub-block">
            <!-- <div class="sub-block-head">
            <div class="sub-block-head-content">
              <h5 class="sub-block-title">Payment Details</h5>
            </div>
          </div> -->
            <div class="column">
              <div class="columns">
                <div class="column is-7">
                  <div class="card settingsCard">
                    <div class="card-header settingsCard-header">
                      <div class="main-heading">
                        <div class="first">Payment Details</div>
                        <div class="second">
                          <!-- <small>Powered by <b>Stripe</b></small> -->
                        </div>
                      </div>
                    </div>
                    <div class="card-body settingsCard-body">
                      <ngx-paypal [config]="payPalConfig"></ngx-paypal>
                      <!-- <form class="checkout-form" [formGroup]="paymentForm">
                    <div class="field">
                      <label for="label">Name of the Card <span
                      class="required">*</span></label>
                      <div class="control">
                        <input class="input" type="text" formControlName="name"
                          placeholder="Name">
                        </div>
                      </div>
                      <div class="field">
                        <label for="label">Card <span
                        class="required">*</span></label>
                        <div class="control">
                          <ngx-stripe-card [options]="cardOptions"
                            [elementsOptions]="elementsOptions"
                          (change)="onChange($event)"></ngx-stripe-card>
                        </div>
                      </div>
                      <div class="field">
                        <label for="label">Email <span class="required">*</span></label>
                        <div class="control">
                          <input class="input" type="text" formControlName="email"
                            placeholder="Email">
                          </div>
                        </div>
                        <div class="field">
                          <label for="label">Company Name <span class="required">*</span></label>
                          <div class="control">
                            <input class="input" type="text" formControlName="email"
                              placeholder="Company Name">
                            </div>
                          </div>
                          <div class="field">
                            <label for="label">Billing Address <span class="required">*</span></label>
                            <div class="control">
                              <textarea  class="textarea"  formControlName="email"
                              placeholder="Billing Address"></textarea>
                            </div>
                          </div>
                          <div class="field">
                            <label for="label">Billing Address 2<span class="required">*</span></label>
                            <div class="control">
                              <textarea  class="textarea"  formControlName="email"
                              placeholder="Billing Address"></textarea>
                            </div>
                          </div>
                          <div class="field">
                            <label for="label">City<span class="required">*</span></label>
                            <div class="control">
                              <input class="input" type="text" formControlName="email"
                                placeholder="City">
                              </div>
                            </div>
                            <div class="field">
                              <label for="label">State<span class="required">*</span></label>
                              <div class="control">
                                <input class="input" type="text" formControlName="email"
                                  placeholder="State">
                                </div>
                              </div>
                              <div class="field">
                                <label for="label">Country<span class="required">*</span></label>
                                <ng-select (change)="chooseCountry($event)"
                                  formGroupName="country" name="country" id="country"
                                  placeholder="Choose/Search country">
                                  <ng-option *ngFor="let country of country_list"
                                  [value]="country">{{country}}</ng-option>
                                </ng-select>
                              </div>
                              <div class="field">
                                <label for="label">Amount $ <span
                                class="required">*</span></label>
                                <div class="control">
                                  <span formControlName="amount"><b>{{subscriptionAmount *
                                  12}}</b></span>
                                </div>
                              </div>
                              <div class="stripe-card" ngxStripeCardGroup
                                [elementsOptions]="elementsOptions">
                                <h4>Enter payment details</h4>
                                <div class="stripe-element">
                                  <ngx-stripe-card-number [options]="cardOptions"
                                  [elementsOptions]="elementsOptions"></ngx-stripe-card-number>
                                </div>
                                <div fxLayout="row" fxLayoutGap="10px">
                                  <div class="w-full stripe-element">
                                    <ngx-stripe-card-expiry
                                    [options]="cardOptions"></ngx-stripe-card-expiry>
                                  </div>
                                  <div class="w-full stripe-element">
                                    <ngx-stripe-card-cvc
                                    [options]="cardOptions"></ngx-stripe-card-cvc>
                                  </div>
                                </div>
                              </div>
                              <button type="submit" class="button is-link is-fullwidth"
                                (click)="pay(payment_method)"
                              [disabled]="paymentForm.invalid">Pay</button>
                            </form> -->
                    </div>
                  </div>
                </div>
                <div class="column is-5">
                  <div class="card settingsCard summaryCard">
                    <div class="card-header summaryCardHeader">
                      <p class="first">Order Summary</p>
                      <p class="second">
                        <a class="upgrade-btn" (click)="changePaymentOptions()"
                          >Change Plan</a
                        >
                      </p>
                    </div>
                    <div class="card-body">
                      <table class="table" style="width: 100%">
                        <tr>
                          <td>Plan</td>
                          <th>{{ subscriptionPlanName }}</th>
                        </tr>
                        <tr>
                          <td>User Count</td>
                          <td>1</td>
                        </tr>
                        <tr>
                          <td>Contract Term</td>
                          <td>12 Months</td>
                        </tr>
                        <tr>
                          <td>Billing Cycle</td>
                          <td>Annually</td>
                        </tr>
                        <tr>
                          <th>Total</th>
                          <th>
                            ${{ subscriptionAmount * 12 }} (${{
                              subscriptionAmount
                            }}/month)
                          </th>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
        }

        <!-- User payment history -->
        @if (tabName === 'payment_history') {
        <div class="card-content">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>#</th>
                <th>Issue Date</th>
                <th>Due Date</th>
                <th>Description</th>
                <th>Payment Method</th>
                <th>Total $</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>4875</th>
                <td>04/31/2023</td>
                <td>05/01/2024</td>
                <td>Absence GPT + LMS</td>
                <td>Stripe</td>
                <td>588.00</td>
                <td>Due</td>
              </tr>
              <tr>
                <th>3871</th>
                <td>04/30/2022</td>
                <td>04/31/2023</td>
                <td>Absence GPT</td>
                <td>Stripe</td>
                <td>348.00</td>
                <td>Paid</td>
              </tr>
            </tbody>
          </table>
        </div>
        }
      </div>
    </div>
  </div>
</section>
